<template>
  <q-layout view="lhh LpR lff">
    <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
    <q-page-container>
      <q-page padding ref="qPage">
        <div class="row justify-between">
          <q-btn class="justify-center q-ma-xs q-pr-md" ripple dense flat color="black" to="/categories">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
        </div>
          <div class="col-12 q-pa-md">
            <div class="text-h5 text-center q-py-md">Nhân sự</div>
          </div>
        <q-card class="row q-my-xs">
          <div class="col-xs-12 q-pa-md">
              <q-table
              :hide-bottom="dataFetched.length > 0"
              flat
              :data="dataFetched"
              :columns="headers"
              row-key="fieldName"
              no-data-label="Không có dữ liệu"
              :pagination.sync="pagination"
              :loading="isFetching"
              class="q-mb-md"
              >
              </q-table>
          </div>
        </q-card>
      </q-page>
    </q-page-container>
  </q-layout>
</template>
<script>
export default {
  name: 'DailyStatistics',
  data() {
    return {
      headers: [
        {
          name: 'no',
          required: true,
          label: 'No',
          align: 'left',
          format: (val, row) => `${row.__index + 1}`,
          sortable: true
        },
        {
          name: 'displayName',
          required: true,
          label: 'Họ và tên',
          align: 'center',
          field: row => row.displayName,
          format: val => `${val ? val : ''}`,
          sortable: true
        },
        {
          name: 'mobile',
          required: true,
          label: 'Số điện thoại',
          align: 'center',
          field: row => row.mobile,
          format: val => `${val ? val : ''}`,
          sortable: true
        },
        {
          name: 'email',
          required: true,
          label: 'Email',
          align: 'center',
          field: row => row._id,
          format: val => `${val ? val : ''}`,
          sortable: true
        },
        {
          name: 'position',
          required: true,
          label: 'Vị trí',
          align: 'center',
          field: row => row.position,
          format: val => `${val ? val : ''}`,
          sortable: true
        }
      ],
      pagination: {
        rowsPerPage: 0,
        sortBy: 'job'
      },
      isFetching: false,
      dataFetched: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      let vm = this
      vm.isFetching = true
      await vm.$query(['Users'])
        .then((res) => {
          let filter = res.data.filter(item => !item.hasOwnProperty('show'))
          vm.dataFetched = filter.sort((a,b) => a.displayName === b.displayName || !a.displayName || !b.displayName ? a._id.localeCompare(b._id) : a.displayName.localeCompare(b.displayName))
        }).catch(error => {
          vm.$q.notify({
            message: error.toString(),
            color: 'red',
            icon: 'error'
          })
        })
      vm.isFetching = false
    }
  }
}
</script>
